import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgCalendarComponent } from './pg-calendar.component';
import { PgCalendarTitleComponent } from './pg-calendar-title/pg-calendar-title.component';
import { PgCalendarActionsComponent } from './pg-calendar-actions/pg-calendar-actions.component';
import { PgCalendarWeekdaysComponent } from './pg-calendar-weekdays/pg-calendar-weekdays.component';
import { PgSelectModule } from '../pg-select/pg-select.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PgCalendarMonthComponent } from './pg-calendar-month/pg-calendar-month.component';
import { PgCalendarDateGridComponent } from './pg-calendar-month/pg-calendar-date-grid/pg-calendar-date-grid.component';
import { PgCalendarGridCellComponent } from './pg-calendar-month/pg-calendar-grid-cell/pg-calendar-grid-cell.component';
import { PgCalendarCursorComponent } from './pg-calendar-cursor/pg-calendar-cursor.component';
import { PgCalendarInputDirective } from './pg-calendar-input.directive';
import { PortalModule } from '@angular/cdk/portal';
import {
  LocalizedMonthNamesService,
  CALENDAR_LOCALIZATION_SERVICE,
} from './lib/localized-month-names.service';
import { PgCalendarFactoryComponent } from './pg-calendar-factory/pg-calendar-factory.component';

@NgModule({
  imports: [CommonModule, PortalModule, ReactiveFormsModule, PgSelectModule],
  declarations: [
    PgCalendarComponent,
    PgCalendarTitleComponent,
    PgCalendarActionsComponent,
    PgCalendarWeekdaysComponent,
    PgCalendarDateGridComponent,
    PgCalendarGridCellComponent,
    PgCalendarMonthComponent,
    PgCalendarCursorComponent,
    PgCalendarInputDirective,
    PgCalendarFactoryComponent,
  ],
  providers: [
    {
      provide: CALENDAR_LOCALIZATION_SERVICE,
      useClass: LocalizedMonthNamesService,
    },
  ],
  exports: [
    PgCalendarComponent,
    PgCalendarInputDirective,
    PgCalendarFactoryComponent,
  ],
  entryComponents: [PgCalendarDateGridComponent],
})
export class PgCalendarModule {}
